import { j as t } from "./kezios-design-system.esm172.js";
import { createElement as i } from "react";
import { Accordion as r } from "@mantine/core";
const x = ({ value: o, title: e, content: m, ...n }) => /* @__PURE__ */ i(r.Item, { ...n, value: o, key: o }, /* @__PURE__ */ t.jsx(r.Control, { children: e }), /* @__PURE__ */ t.jsx(r.Panel, { children: m }));
export {
  x as Item
};
